var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { CompanyConfiguration } from "./../models/V1/Companies/FileUploadConfiguration/CompanyConfiguration";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class CompaniesFileUploadConfiguration {
  /**
   * Creates an instance of CompaniesFileUploadConfiguration.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CompaniesFileUploadConfiguration
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetRq_ _getRq
   * @returns Promise<GetRq_>
   * @memberof CompaniesFileUploadConfiguration
   */
  get(pGetRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/fileuploadconfiguration",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "companyId", value: pGetRq.companyId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: CompanyConfiguration },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param AddRq_ _addRq
   * @returns Promise<AddRq_>
   * @memberof CompaniesFileUploadConfiguration
   */
  add(pAddRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/fileuploadconfiguration",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "companyId", value: pAddRq.companyId, required: true }]);
    client.addBody({ value: pAddRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof CompaniesFileUploadConfiguration
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/fileuploadconfiguration",
      "PATCH",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "companyId", value: pUpdateRq.companyId, required: true }]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
